import ErrorCircle from "@material-symbols/svg-500/rounded/error.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const ErrorCircleIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: ErrorCircle });
	return <Icon />;
};

export default memo(ErrorCircleIcon);
